import { useState } from "react";
import { WalletTab } from "../../hooks/use-wallet-tab";
import { WalletPageTabWrapper, WalletPageTabItem } from "./style";
import { useWalletContext } from "../../hooks/wallet-context";

const WalletPageTab = () => {
  const { setWalletTab, isWalletTab } = useWalletContext();
  const [activeTab, setActiveTab] = useState(WalletTab.WALLET);

  const handleClick = (tab: WalletTab) => {
    setWalletTab(tab);
    setActiveTab(tab);
  };

  const tabList = [
    { title: "매장", tab: WalletTab.WALLET },
    { title: "히스토리", tab: WalletTab.HISTORY },
  ];

  return (
    <WalletPageTabWrapper activeTab={activeTab}>
      {tabList.map((item, index) => (
        <WalletPageTabItem
          key={index}
          isSelected={isWalletTab(item.tab)}
          onClick={() => handleClick(item.tab)}
        >
          {item.title}
        </WalletPageTabItem>
      ))}
      <div className="background" />
    </WalletPageTabWrapper>
  );
};

export default WalletPageTab;
